// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testTemplateRevisionId } from './TestTemplateRevision';
import { testAttributeCodeCode } from './TestAttributeCode';
import { z } from 'zod';
export const testTemplateRevisionCurve = z.object({
    test_template_revision_id: testTemplateRevisionId,
    analyte_code: testAttributeCodeCode,
});
export const testTemplateRevisionCurveInitializer = z.object({
    test_template_revision_id: testTemplateRevisionId,
    analyte_code: testAttributeCodeCode,
});
export const testTemplateRevisionCurveMutator = z.object({
    test_template_revision_id: testTemplateRevisionId.optional(),
    analyte_code: testAttributeCodeCode.optional(),
});
//# sourceMappingURL=TestTemplateRevisionCurve.js.map